/**
 * Vehicle Service
 * Handles API calls for vehicle data
 */

import { API_ENDPOINTS } from '@/config/api';
import { VehicleDetailDto } from '@/types/manage';
import { HttpClient } from './httpClient';

/**
 * Vehicle Service
 */
export const vehicleService = {
  /**
   * Fetch vehicles assigned to a driver
   * GET /Vehicles/driver/{driverId}
   */
  async getVehiclesByDriver(driverId: string): Promise<VehicleDetailDto[]> {
    const url = API_ENDPOINTS.vehicles.byDriver(driverId);
    const response = await HttpClient.fetchWithAuth<VehicleDetailDto[]>(url);
    return ((response as { data?: VehicleDetailDto[] }).data ?? response) as VehicleDetailDto[];
  },

  /**
   * Fetch a single vehicle by ID (works for fleet, personal, and rental vehicles)
   * GET /Vehicles/{vehicleId}
   */
  async getVehicleById(vehicleId: string): Promise<VehicleDetailDto> {
    const url = API_ENDPOINTS.vehicles.getById(vehicleId);
    const response = await HttpClient.fetchWithAuth<VehicleDetailDto>(url);
    return ((response as { data?: VehicleDetailDto }).data ?? response) as VehicleDetailDto;
  },
};
